import React, { useState } from "react";
import useAuth from "../../auth/useAuth";
import { foodAnalyzerService } from "./analyzerService";
import FoodAnalysisResults from "./analyzerResults";
import FoodAnalyzerHelp from "./analyzerHelp";
import HelpIcon from '@mui/icons-material/Help';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';


const FoodAnalyzer = () => {
  const { isAuthenticated, redirectToAuth, loading } = useAuth();
  const [foodItem, setFoodItem] = useState("");
  const [apiResponse, setApiResponse] = useState(null);
  const [buttonText, setButtonText] = useState("Analyze Food Safety");
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  
  const handleInputChange = (event) => {
    setFoodItem(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!isAuthenticated) {
      console.warn("User not authenticated. Redirecting...");
      redirectToAuth();
      return;
    }

    try {
      const response = await foodAnalyzerService(foodItem, setButtonText, setButtonDisabled);
      setApiResponse(response);
    } catch (error) {
      console.error(error);
    }
  };

  const handleHelpOpen = () => setHelpOpen(true);
  const handleHelpClose = () => setHelpOpen(false);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="section" id="safeFood" >
        <h2>Food Analyzer</h2>
        <div className="list-section" style={{ position: "relative", padding: "14px", minHeight: "200px" }}>
            <IconButton
                onClick={handleHelpOpen}
                aria-label="help"
                style={{
                position: "absolute",
                top: 5,
                right: 5,
                color: "#67761F",
                }}
            >
                <HelpIcon />
            </IconButton>
            <div className="list-container">
            <p>Concerned about the food you are eating?  Type in your food and see the results.</p>
                <div className="basic-input">
                    <form 
                    onSubmit={handleSubmit}>
                        <input
                        type="text"
                        value={foodItem}
                        onChange={handleInputChange}
                        placeholder="Enter a food item"
                        required
                        />
                        <button 
                        className="btn-primary"
                        type="submit" 
                        disabled={buttonDisabled}>
                        {buttonText}
                        </button>
                    </form>
                </div>
            </div>
      </div>
      {apiResponse && <FoodAnalysisResults response={apiResponse}/>} 

      <Dialog open={helpOpen} onClose={handleHelpClose} fullWidth maxWidth="md">
        <DialogTitle>
          Help - Food Analyzer User Manual
          <IconButton
            aria-label="close"
            onClick={handleHelpClose}
            style={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <FoodAnalyzerHelp />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default FoodAnalyzer;